import cn from 'classnames';
import { memo, useRef, type FC } from 'react';
import { FormProvider } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { FormDescriptionEditor } from '@widgets/shared/Forms/DescriptionEditor/index.tsx';
import { MediumHeader } from '@shared/ui';
import { ModalMiddle } from 'library/components/common';
import { useFormRecommend } from './model/use-recommend-form';
import { useRecommendModal } from './model/use-recommend-modal';
import * as st from './styles.module.scss';

export const ModalRecommend: FC = memo(() => {
  const { recommendation } = useRecommendModal();
  const {
    methods,
    linkCopy,
    getRecommendAction,
    step,
    showCloseBtn,
    onClose,
    onCopy,
    setValue,
    programName,
    hash,
    isLinkCopied,
    setIsLinkCopied,
  } = useFormRecommend();

  const theParagraphRef = useRef<HTMLParagraphElement>(null);

  const handleCopy = () => {
    onCopy(theParagraphRef?.current?.innerText);
  };

  const programNameForText = programName ? `\n«${programName}»` : '.';
  return (
    <ModalMiddle
      isOpen={!!recommendation.programId}
      close={onClose}
      onRequestClose={onClose}
      showClose={showCloseBtn}
    >
      <MediumHeader title="Рекомендация" onClose={onClose} />
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(getRecommendAction)} className={st.body}>
          <div className={st.step}>
            {step === 1 && (
              <>
                <div className={st.step__workspace}>
                  <div className={st.editor}>
                    <FormDescriptionEditor
                      whereUse={'inModal'}
                      contentClassName={st.editorContent}
                      fieldLabel="Комметарий"
                      hash={hash}
                      onChange={(v) => setValue('comment', v, { shouldDirty: v !== '' })}
                    />
                    <p className={st.title}>
                      Оставленный комментарий будет виден только перешедшему по данной ссылке
                      рекомендации
                    </p>
                  </div>

                  {methods.formState.errors.comment && <span>Укажите комментарий</span>}
                </div>
                <div className={st.step__buttons}>
                  <button type="submit">Далее</button>
                </div>
              </>
            )}
            {step === 2 && (
              <>
                <div className={cn(st.step__workspace, st.stepTwo)}>
                  <p
                    className={st.view}
                    ref={theParagraphRef}
                    onClick={() => setIsLinkCopied(false)}
                  >
                    Рекомендую вам для просмотра видеопрограмму
                    <br />
                    {programNameForText}
                    <br />
                    <br />
                    Ссылка на видеопрограмму: 👉{' '}
                    <Link className={st.link} to={linkCopy} target={'_blank'}>
                      {linkCopy}
                    </Link>
                  </p>
                  <h3 className={st.title}>
                    {'Скопируйте текст сообщения и отправьте любым удобным для Вас способом'}
                  </h3>
                </div>
                <div className={cn(st.step__buttons, isLinkCopied && st.copied)}>
                  {isLinkCopied ? (
                    <p className={st.copiedField}>Скопировано в буфер обмена</p>
                  ) : (
                    <button type="button" onClick={handleCopy}>
                      Скопировать
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
        </form>
      </FormProvider>
    </ModalMiddle>
  );
});
